import computeOptions from '@ui-kit/scripts/utils/options-mapper';
import searchFn from '@ui-kit/scripts/utils/search';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    show: {
      type: Boolean,
      required: false,
      default: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },
    showCounters: {
      type: Boolean,
      default: false,
    },
    parentSearch: {
      type: String,
      default: ''
    },
    itemAlign: {
      type: String,
      default: 'start',
      validator: value => ['center', 'start', 'end'].includes(value),
    },
    noResultsLabel: {
      type: String,
      default: 'No results for'
    },
  },
  data() {
    return {
      searchValue: '',
    };
  },
  computed: {
    selectedOpt() {
      return this.options.find(opt => opt.optValue === this.value) || null;
    },
    optionsObject() {
      const searchData = this.searchValue || this.parentSearch;
      return computeOptions(searchData ? this.search(searchData) : this.options);
    },
  },
  methods: {
    close() {
      this.searchValue = '';
      this.$emit('closed', true);
    },
    search(query) {
      return searchFn(this.options, query);
    },
    shouldShowCounterIndicator(option) {
      return this.showCounters && option.optCounter !== undefined;
    },
    selectOption(option) {
      if (option.disabled) {
        return;
      }
      this.$emit('change', option.optValue);
      // this.close({}, 3);
    },
  },
};
